// =====================================================================
//  Rapport de validation d'un paquet : erreurs (bloquantes),
//  avertissements et conseils. Codes : docs/TEMPLATE_PACKAGE_FORMAT.md § 5.
// =====================================================================

export interface IPackageIssue {
    code: string;
    message: string;
}

export class PackageReport {
    readonly Errors: Array<IPackageIssue> = [];
    readonly Warnings: Array<IPackageIssue> = [];
    readonly Advices: Array<IPackageIssue> = [];

    public get HasErrors(): boolean {
        return this.Errors.length > 0;
    }

    public get IsEmpty(): boolean {
        return !this.Errors.length && !this.Warnings.length && !this.Advices.length;
    }

    public Error = (code: string, message: string) => PackageReport.#add(this.Errors, code, message);
    public Warning = (code: string, message: string) => PackageReport.#add(this.Warnings, code, message);
    public Advice = (code: string, message: string) => PackageReport.#add(this.Advices, code, message);

    static #add = (list: Array<IPackageIssue>, code: string, message: string) => {
        if (!list.some(x => x.code === code && x.message === message))
            list.push({code, message});
    };

    /** Texte brut du rapport, à copier pour l'agent IA. */
    public ToText = (): string => {
        const parts: Array<string> = [];
        const section = (title: string, list: Array<IPackageIssue>) => {
            if (!list.length)
                return;
            parts.push(`${title} (${list.length}) :`);
            list.forEach(x => parts.push(`  - ${x.code}  ${x.message}`));
        };
        section("Erreurs bloquantes", this.Errors);
        section("Avertissements", this.Warnings);
        section("Conseils", this.Advices);
        return parts.length ? parts.join("\n") : "Aucun problème détecté.";
    };
}
